var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCanada(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7 0h16v24H7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c53a28",
    d: "M0 0h8v24H0zm22 24V0h8v24zm-6.72-5.83-.14-2.64a.3.3 0 0 1 .34-.3l2.63.46-.36-.98a.2.2 0 0 1 .06-.22l2.88-2.34-.65-.3a.2.2 0 0 1-.1-.24l.57-1.75-1.66.35a.2.2 0 0 1-.22-.12l-.32-.75-1.3 1.39a.2.2 0 0 1-.34-.18l.63-3.22-1 .58a.2.2 0 0 1-.28-.08l-1.02-2-1.02 2a.2.2 0 0 1-.26.09l-.02-.01-1-.58.63 3.22a.2.2 0 0 1-.34.18l-1.3-1.4-.32.76a.2.2 0 0 1-.22.12l-1.66-.35.57 1.75a.2.2 0 0 1-.1.24l-.65.3 2.88 2.34a.2.2 0 0 1 .06.22l-.36.98 2.63-.46a.3.3 0 0 1 .34.23v.07l-.14 2.64z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanada);
export default __webpack_public_path__ + "static/media/canada.00bccdac95e33cf8a25d0dcabd7d9921.svg";
export { ForwardRef as ReactComponent };